export const FAHRENHEIT = "app/store/settings/FAHRENHEIT";
export const CELSIUS = "app/store/settings/CELSIUS";
export const SET_TEMPERATURE_UNIT = "app/store/settings/SET_TEMPERATURE_UNIT";
